// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QAWH","tabsBox":"styles_tabsBox__3_4s9","createButton":"styles_createButton__3E4Jk"};